import { Button } from 'reactstrap';

import FieldInfo from '../field-info';

/**
 * Progressive disclosure for technical fields. `alwaysOpen` keeps the fields
 * visible when they are required (custom provider) or when the API returned
 * errors for them, so the user can always reach an invalid field.
 */
const AdvancedSection = ({
    id,
    title,
    info,
    isOpen = false,
    alwaysOpen = false,
    onToggle,
    children,
}) => (
    <div className="mailer-settings__advanced pt-3 mt-2 border-top">
        {alwaysOpen ? (
            <h6 className="font-size-13 fw-semibold mb-3">
                {title}
                {info && (
                    <FieldInfo id={`info-${id}`}>
                        {info}
                    </FieldInfo>
                )}
            </h6>
        ) : (
            <div className="d-flex align-items-center mb-0">
                <Button
                    color="link"
                    type="button"
                    className="p-0 fw-semibold text-decoration-none"
                    onClick={onToggle}
                >
                    <i className={`mdi ${isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right'} me-1`} />
                    {title}
                </Button>
                {info && (
                    <FieldInfo id={`info-${id}`}>
                        {info}
                    </FieldInfo>
                )}
            </div>
        )}

        {(alwaysOpen || isOpen) && (
            <div className={alwaysOpen ? '' : 'mt-3'}>
                {children}
            </div>
        )}
    </div>
);

export default AdvancedSection;
